<template>
  <div>
    <breadcrumb>
      <template v-slot:1
        ><router-link :to="{ name: 'configuracion-carta' }">{{
          $t("configuracionCarta")
        }}</router-link></template
      >
      <template v-slot:2>{{ $t("zonasDeReparto") }}</template>
    </breadcrumb>

    <CabeceraInformes
      :idBusiness="idBusiness"
      :listBusinesses="listBusinesses"
      :idTpv="idTpv"
      :listTpv="listTpv"
      :quitarFechas="true"
      :quitarConsultas="true"
      id="cabecera"
    />
    <div class="col-md-12 ml-0">
      <div class="card" style="padding-top:30px;margin-bottom:15px;">
        <div class="row">
          <div class="col-md-0 ml-3">
            <button
              type="button"
              @click="abrirModalNuevo()"
              class="btn btn-primary"
            >
              <i class="fas fa-plus fa-xs"></i>
            </button>
          </div>
          <div
            v-if="listaAreas.length > 0"
            class="col-md-0 ml-3"
            style="pointer-events: none"
          >
            <span
              class="dot"
              :style="
                'height: 35px; width: 35px;display: inline-block;border-radius: 50%;background-color:' +
                  areaSeleccionada.color +
                  ';'
              "
            ></span>
          </div>
          <div class="col-md-2 ml-1">
            <div class="form-group">
              <el-select
                class="select-default"
                @change="cambiarZonaActual()"
                v-model="idAreaSeleccionada"
                placeholder="Seleccione una zona"
              >
                <el-option
                  v-for="(area, index) in listaAreas"
                  class="select-primary"
                  :value="area.id"
                  :label="area.tipo == 'C' ? area.nombreMostrar + ' [' + area.puntosPoligono + ']' : area.nombreMostrar"
                  :key="index"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="listaAreas.length > 0" class="col-md-0 ml-2">
            <button
              type="button"
              class="btn btn-primary"
              @click="abrirModalDetalles()"
            >
              <i class="fas fa-pencil-alt fa-xs"></i>
            </button>
          </div>
          <div v-if="listaAreas.length > 0" class="col-md-0 ml-4">
            <button
              type="button"
              class="btn btn-danger"
              @click="abrirModalEliminar()"
            >
              <i class="fas fa-trash fa-xs"></i>
            </button>
          </div>
          <div v-if="listaAreas.length > 0" class="col-md-0 ml-4">
            <button class="btn btn-success" @click="guardarMapa">
              <i class="fas fa-check"></i> {{ $t("guardarCambios") }}
            </button>
          </div>
          <!--<el-color-picker v-model="areaSeleccionada.color"></el-color-picker>-->
          <!--<div class="col-md-5">

                <div class="form-group">
                  <el-color-picker v-model="color1"></el-color-picker>
                </div>
                <div class="form-group">
                  <button type="button" class="btn btn-outline-primary">+</button>
                </div>


                <div class="form-group">
                  <el-select v-model="areaSeleccionada" placeholder="Select">
                    <el-option
                      v-for="area in listaAreas"
                      :key="area.value"
                      :label="area.label"
                      :value="area.value">
                    </el-option>
                  </el-select>
                </div>

              </div>-->
          <div class="float-right ml-3">
            <VueToggles v-if="listaAreas.length > 0"
              id="switchZonas"
              @click="openModalCerrarZonas()"
              :value="zonasAbiertas"
              height="35"
              width="150"
              fontSize="14"
              fontWeight="bold"
              :checkedText="$t('zonasRepartoActivadas')"
              :uncheckedText="$t('zonasRepartoDesactivadas')"
              checkedBg="#28a745"
              uncheckedBg="lightgrey"
            ></VueToggles>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="col-md-12 ml-0" v-else>
      <div class="card" style="padding-top:30px;margin-bottom:15px;">
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              {{ $t("loSentimosSuNegocioNoTieneContratadoEsteModulo") }}
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <div id="mainZonas">
      <div id="map-canvas"></div>
      <div>
        <!--<button class="btn btn-primary" @click="removeMapMarkers">
          Borrar Mapa
        </button>
        <router-link :to="{ name: 'configuracion-carta' }">
          <button class="btn btn-danger">
            <i class="fa fa-window-close"></i> {{ $t("cancelar") }}
          </button>
        </router-link>-->
      </div>
    </div>

    <modal
      name="modal-detalles-zona"
      :draggable="false"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            <strong
              >{{ $t("editarZona") }}: {{ areaSeleccionada.nombre }}</strong
            >
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-10">
              <div class="form-group">
                <label for="nombre">{{ $t("nombre") }}</label>
                <el-input v-model="areaAEditar.nombre"> </el-input>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="color">{{ $t("color") }}</label>
                <el-color-picker
                  v-if="screen > 700"
                  :predefine="colores"
                  v-model="areaAEditar.color"
                ></el-color-picker>
                <input
                  v-if="screen <= 700"
                  type="color"
                  v-model="areaAEditar.color"
                />
              </div>
            </div>
          </div>
          <div class="row" v-if="areaAEditar.tipo == 'C'">
            <div class="col-md-6">
              <div class="form-group">
                <label for="codigoPostal">{{ $t("codigoPostal") }}</label>
                <input v-model="areaAEditar.puntosPoligono" class="form-control" maxlength="5" v-on:keypress="comprobarCodigoEditar"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="costeReparto">{{ $t("costeDeReparto") }}</label>
                <vue-numeric
                  currency="€"
                  inputmode="decimal"
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  :precision="2"
                  v-model="areaAEditar.costeReparto"
                  @keydown.native="$methods.evitarComasDecimales"
                >
                </vue-numeric>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="pedidoMinimo">{{ $t("pedidoMinimo") }}</label>
                <vue-numeric
                  currency="€"
                  inputmode="decimal"
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  :precision="2"
                  v-model="areaAEditar.pedidoMinimo"
                  @keydown.native="$methods.evitarComasDecimales"
                >
                </vue-numeric>
              </div>
            </div>
            <div class="col-md-3" v-if="areaAEditar.tipo == 'R'">
              <div class="form-group">
                <label for="kilometrosDelArea">{{ $t("kilometrosDelArea") }}</label>
                <vue-numeric
                  currency="km"
                  inputmode="decimal"
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  :precision="2"
                  v-model="radioZona"
                  @keydown.native="$methods.evitarComasDecimales"
                >
                </vue-numeric>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="desactivarZona">{{ $t("estado")}}</label>
                <VueToggles 
                  id="switchZonasBajas"
                  @click="cambiarBajaZona(areaAEditar.baja)"
                  :value="!areaAEditar.baja"
                  height="35"
                  width="110"
                  fontSize="14"
                  fontWeight="bold"
                  :checkedText="$t('activa')"
                  :uncheckedText="$t('inactiva')"
                  checkedBg="#28a745"
                  uncheckedBg="lightgrey"
                ></VueToggles>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModal()" class="btn btn-danger">
              <i class="fas fa-times"></i>
              {{ $t("cancelar") }}
            </button>
            <button
              @click="editarZona()"
              :disabled="inProgress"
              class="btn btn-success ml-3"
            >
              <i class="fas fa-check"></i>
              {{ $t("confirmar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="modal-nueva-zona"
      :draggable="false"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            <strong>{{ $t("crearNuevaZona") }}</strong>
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-10">
              <div class="form-group">
                <label for="nombre">{{ $t("nombre") }}</label>
                <el-input v-model="areaNueva.nombre"> </el-input>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="color">{{ $t("color") }}</label>
                <el-color-picker
                  v-if="screen > 700"
                  :predefine="colores"
                  v-model="areaNueva.color"
                ></el-color-picker>
                <input
                  v-if="screen <= 700"
                  type="color"
                  v-model="areaNueva.color"
                />
              </div>
            </div>
          </div>
          <div class="row" v-if="tipoZona == 'R'">
            <div class="col-md-6">
              <div class="form-group">
                <label for="kilometrosDelArea">{{ $t("kilometrosDelArea") }}</label>
                <vue-numeric
                  currency="km"
                  inputmode="decimal"
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  :precision="2"
                  v-model="radioZona"
                  @keydown.native="$methods.evitarComasDecimales"
                >
                </vue-numeric>
              </div>
            </div>
          </div>
          <div class="row" v-if="tipoZona == 'C'">
            <div class="col-md-6">
              <div class="form-group">
                <label for="codigoPostal">{{ $t("codigoPostal") }}</label>
                <input v-model="areaNueva.puntosPoligono" class="form-control" maxlength="5" v-on:keypress="comprobarCodigo"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="costeReparto">{{ $t("costeDeReparto") }}</label>
                <vue-numeric
                  currency="€"
                  inputmode="decimal"
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  :precision="2"
                  v-model="areaNueva.costeReparto"
                  @keydown.native="$methods.evitarComasDecimales"
                >
                </vue-numeric>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="pedidoMinimo">{{ $t("pedidoMinimo") }}</label>
                <vue-numeric
                  currency="€"
                  inputmode="decimal"
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  :precision="2"
                  v-model="areaNueva.pedidoMinimo"
                  @keydown.native="$methods.evitarComasDecimales"
                >
                </vue-numeric>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="pedidoMinimo">{{ $t("tipoDeZona") }}</label>
                <el-select 
                  class="select-default"
                  size="large"
                  v-model="tipoZona"
                  filterable
                  :placeholder="$t('seleccioneUnTipo')"
                >
                  <el-option              
                    v-for="(zona, index) in listZonas"
                    class="select-primary"
                    :value="zona.code"
                    :label="zona.name"
                    :key="index">

                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModal()" class="btn btn-danger">
              <i class="fas fa-times"></i>
              {{ $t("cancelar") }}
            </button>
            <button
              @click="crearZona()"
              :disabled="inProgress"
              class="btn btn-success ml-3"
            >
              <i class="fas fa-check"></i>
              {{ $t("confirmar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { Loading, ColorPicker, Select, Option } from "element-ui";
import { VueToggles } from "vue-toggles";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "../../../../../components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
export default {
  name: "ZonasCarta",
  components: {
    Breadcrumb,
    CabeceraInformes,
    ColorPicker,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      loading: null,
      map: null,
      myPolygon: null,
      listaAreas: [],
      listDatosAreas: [],
      listPolygons: [],
      listBusinesses: [],
      idsTPV: [],
      listTpv: [],
      idBusiness: 0,
      idTpv: 0,
      puntoListener: null,
      screen: "",
      inProgress: false,
      permisos: false,
      center: {
        //CENTRO DE SEVILLA
        lat: 37.3903324,
        lng: -5.9963726,
      },
      tipoZona: "Z",
      listZonas: [
        {
          code: "Z",
          name: "Poligono"
        },
        {
          code: "R",
          name: "Radio",
        },
        {
          code: "C",
          name: "Codigo postal"
        }
      ],
      colores: [
        "#D291BC",
        "#8e4483",
        "#7accb8",
        "#339D1E",
        "#FF9E5F",
        "#D73200",
        "#bc2731",
        "#505d7e",
        "#464e4d",
      ],
      idAreaSeleccionada: "",
      areaNueva: {
        nombre: "",
        costeReparto: "",
        pedidoMinimo: "",
        puntosPoligono: "",
        color: "#000000",
      },
      areaSeleccionada: {
        idTpv: "",
        nombre: "",
        costeReparto: "",
        pedidoMinimo: "",
        puntosPoligono: "",
        color: "",
        baja: 0,
      },
      areaAEditar: {
        id: "",
        idTpv: "",
        nombre: "",
        costeReparto: "",
        pedidoMinimo: "",
        puntosPoligono: "",
        color: "",
        baja: 0,
      },
      negocioLat: "",
      negocioLng: "",
      color1: "#409EFF",
      zonasAbiertas: false,
      radioZona: 1,
    };
  },
  computed: {
    zoom() {
      //valores 0 a 21
      let maxLeft,
        maxRight,
        maxTop,
        maxBottom = null;

      if (this.listaAreas.length > 0) {
        this.listaAreas.forEach((area) => {
          if(area.tipo == 'Z') {
            area.puntosPoligono.forEach((poligono) => {
              maxLeft =
                !maxLeft || poligono.lng < maxLeft ? poligono.lng : maxLeft;
              maxRight =
                !maxRight || poligono.lng > maxRight ? poligono.lng : maxRight;
              maxTop = !maxTop || poligono.lat < maxTop ? poligono.lat : maxTop;
              maxBottom =
                !maxBottom || poligono.lat > maxBottom ? poligono.lat : maxBottom;
            });
          }
        });

        const metrosDistancia = google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(maxLeft, maxTop),
          new google.maps.LatLng(maxRight, maxBottom)
        );
        const zoom = 15 - Math.floor(metrosDistancia) / 10000;

        return zoom;
      } else {
        const zoom = 16;

        return zoom;
      }
    },
    coloresValidos() {
      return ["#464e4d", "#bc2731", "#8e4483", "#7accb8", "#505d7e"];
    },
  },

  methods: {
    cambiarBajaZona(bajaZona) {
      this.areaAEditar.baja = !this.areaAEditar.baja;
    }, 
    comprobarCodigo: function(event) {
      if(event.key && event.key.match(/[a-zA-Z]/)) {
        event.preventDefault();
      } 
      return this.areaNueva.puntosPoligono;
    },
    comprobarCodigoEditar: function(event) {
      if(event.key && event.key.match(/[a-zA-Z]/)) {
        event.preventDefault();
      } 
      return this.areaAEditar.puntosPoligono;
    },
    openModalCerrarZonas() {
      this.zonasAbiertas = !this.zonasAbiertas;
      this.setConfigTpv();
    },
    //TODO borrar todas las zonas
    removeMapMarkers() {
      this.listPolygons.forEach((poligono) => {
        poligono.setMap(null);
      });
      this.listPolygons = [];
      this.listaAreas = [];
      this.idAreaSeleccionada = "";
    },

    quitarTodosPoligonosMapa() {
      this.initialize();
    },

    abrirModalDetalles() {
      this.screen = screen.width;
      //Creo una variable temporal para almacenar la información del área seleccionada e igualo el área a editar con la variable
      let nuevaArea = this.areaSeleccionada;
      this.areaAEditar.nombre = nuevaArea.nombre;
      this.areaAEditar.color = nuevaArea.color;
      this.areaAEditar.costeReparto = nuevaArea.costeReparto;
      this.areaAEditar.pedidoMinimo = nuevaArea.pedidoMinimo;
      this.areaAEditar.puntosPoligono = nuevaArea.puntosPoligono;
      this.areaAEditar.idTpv = nuevaArea.idTpv;
      this.areaAEditar.id = nuevaArea.id;
      this.areaAEditar.tipo = nuevaArea.tipo;
      this.areaAEditar.baja = nuevaArea.baja;

      if(this.areaAEditar.tipo == "R") {
        this.radioZona = nuevaArea.puntosPoligono.radius / 1000;
      }

      this.$modal.show("modal-detalles-zona");
    },

    abrirModalNuevo() {
      this.screen = screen.width;
      this.areaNueva = {};
      this.areaNueva.color = "#000000";
      this.$modal.show("modal-nueva-zona");
    },
    cerrarModal() {
      this.$modal.hide("modal-detalles-zona");
      this.$modal.hide("modal-nueva-zona");
    },
    anadirPoligonoMapa(puntos) {
      const color = this.coloresValidos[
        Math.floor(Math.random() * 10) % this.coloresValidos.length
      ];

      this.myPolygon = new google.maps.Polygon({
        paths: puntos,
        draggable: true, // turn off if it gets annoying
        editable: true,
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.35,
      });
      this.myPolygon.setMap(this.map);
      this.puntoListener = puntos;
      this.listaAreas.push(puntos);
      this.listPolygons.push(this.myPolygon);
    },
    pincharPoligono(id) {
      this.idAreaSeleccionada = id;

      this.listaAreas.forEach((area) => {
        if (area.id == this.idAreaSeleccionada) {
          //Si la id que ha seleccionado en el mapa coincide con la de la zona, se cambia el areaSeleccionada
          let nuevaArea = area;
          this.areaSeleccionada = nuevaArea;
        }
      });

      //Permito que sea editable el polígono que se ha clickado
      this.listPolygons.forEach((polygon) => {
        if (polygon.customID == this.idAreaSeleccionada) {
          polygon.setOptions({ draggable: true, editable: true });
        } else {
          polygon.setOptions({ draggable: false, editable: false });
        }
      });
    },
    pintarPoligonosEnMapa() {
      let vm = this;
      this.listaAreas.forEach((poligono) => {
        //Permito que el area por defecto sea draggable y editable
        if(poligono.tipo != "C") {
          let editable = false;
          if (poligono.id == this.idAreaSeleccionada) {
            editable = true;
          }

          if(poligono.tipo == "Z") {

            this.myPolygon = new google.maps.Polygon({
              paths: poligono.puntosPoligono,
              draggable: editable, // turn off if it gets annoying
              editable: editable,
              strokeColor: poligono.color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: poligono.color,
              fillOpacity: 0.35,
              customID: poligono.id,
            });
          } else if (poligono.tipo == "R") {

            this.myPolygon = new google.maps.Circle({
              center: {lat: poligono.puntosPoligono.center.lat, lng: poligono.puntosPoligono.center.lng},
              radius: poligono.puntosPoligono.radius,
              draggable: editable,
              editable: editable,
              strokeColor: poligono.color,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: poligono.color,
              fillOpacity: 0.35,
              customID: poligono.id,
            });
          }
    
          this.myPolygon.addListener("click", function(event) {
            vm.pincharPoligono(this.customID);
          });

          this.myPolygon.setMap(this.map);
          this.listPolygons.push(this.myPolygon);
        }
      });
    },
    getPuntosMapa() {
      this.listaAreas = [];
      this.listPolygons = [];
      this.idAreaSeleccionada = "";
      this.areaSeleccionada = {};

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idTpv: this.idTpv,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getMapaZonas", config)
        .then(function(response) {
          if (response.data.response) {
            //const res = JSON.parse(response.data.result.puntosPoligono);
            vm.listaAreas = response.data.result ? response.data.result : [];

            vm.listaAreas.forEach((area) => {
              if(area.tipo != 'C') {
                area.puntosPoligono = JSON.parse(area.puntosPoligono);
              }
            });
            let number = response.data.result[0].id;
            vm.idAreaSeleccionada = number;
            vm.areaSeleccionada = response.data.result[0];

            //vm.calcularZoom()
          } else {
            vm.listaAreas = [];
          }

          vm.initialize();
          vm.calcularCentro();
          vm.pintarPoligonosEnMapa();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    setConfigTpv() {
      this.loading = Loading.service({ text: "Cargando..." });
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: {'Authorization': "Bearer " + this.$store.getters.jwt},
      };
      var params = {
        idTpv: this.idTpv,
        numConfig: 43,
        valor: this.zonasAbiertas ? 1 : 0,
        jwt: this.$store.getters.jwt
      };

      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "general/setConfigBusinessInfo",
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
          numConfig: 43,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.zonasAbiertas = true;
          }else{
            vm.zonasAbiertas = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getBusiness() {
      this.loading = Loading.service({ text: "Cargando..." });
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.listBusinesses = response.data.result;
          vm.getTpv();
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    cambioBusiness(idBusinessData, listTpv) {
      this.loading = Loading.service({ text: "Cargando..." });
      this.quitarTodosPoligonosMapa();
      this.idBusiness = idBusinessData;
      this.idTpv = 0;
      this.listaAreas = [];
      this.getTpv();
    },
    emitirConsulta() {},
    cambioTpv(idTpvData) {
      this.idTpv = idTpvData;
      this.listaAreas = [];
      getPuntosMapa();
    },
    cambioHora(dates) {},
    crearZona() {
      if (this.checkCampos("N")) {
        this.inProgress = true;
        let vm = this;

        if(this.tipoZona == "Z") {
          //Creo los puntos para el nuevo polígono
          const punta2 = 0.002;

          let puntosPoligono = [
            new google.maps.LatLng(
              parseFloat(this.map.getCenter().lat() - punta2).toFixed(6),
              parseFloat(this.map.getCenter().lng() + punta2).toFixed(6)
            ),
            new google.maps.LatLng(
              parseFloat(this.map.getCenter().lat() + punta2).toFixed(6),
              parseFloat(this.map.getCenter().lng() + punta2).toFixed(6)
            ),
            new google.maps.LatLng(
              parseFloat(this.map.getCenter().lat() + punta2).toFixed(6),
              parseFloat(this.map.getCenter().lng() - punta2).toFixed(6)
            ),
            new google.maps.LatLng(
              parseFloat(this.map.getCenter().lat() - punta2).toFixed(6),
              parseFloat(this.map.getCenter().lng() - punta2).toFixed(6)
            ),
          ];

          //Inicio el nuevo polígono
          let poligono = new google.maps.Polygon({
            paths: puntosPoligono,
            draggable: true, // turn off if it gets annoying
            editable: true,
            strokeColor: vm.areaNueva.color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: vm.areaNueva.color,
            fillOpacity: 0.35,
          });


          //Saco los datos del polígono
          var len = poligono.getPath().getLength();
          let puntos = [];

          //Recorro los datos
          for (var i = 0; i < len; i++) {
            const lat = poligono
              .getPath()
              .getAt(i)
              .lat();
            const lng = poligono
              .getPath()
              .getAt(i)
              .lng();
            puntos.push(new google.maps.LatLng(lat, lng));
          }

          //Los añado al modelo
          this.areaNueva.puntosPoligono = JSON.stringify(puntos);

        } else if (this.tipoZona == "R") {

          let centro = new google.maps.LatLng(
            parseFloat(this.map.getCenter().lat()).toFixed(6),
            parseFloat(this.map.getCenter().lng()).toFixed(6)
          );

          let poligono = new google.maps.Circle({
            center: centro,
            radius: this.radioZona * 1000,
            draggable: true,
            editable: true,
            strokeColor: vm.areaNueva.color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            map: this.map,
            fillColor: vm.areaNueva.color,
            fillOpacity: 0.35,
          });

          this.areaNueva.puntosPoligono = '{"center": {"lat":'+parseFloat(this.map.getCenter().lat()).toFixed(6)+
                                          ',"lng":'+parseFloat(this.map.getCenter().lng()).toFixed(6)+'},"radius": '+this.radioZona * 1000+'}';
        } 

        //Preparo la petición
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idTpv: this.idTpv,
          areaNueva: this.areaNueva,
          tipo: this.tipoZona,
        };

        //Mando la petición
        this.axios
          .post(this.$store.getters.apiUrl + "delivery/newZona", params, config)
          .then(function(response) {
            vm.inProgress = false;

            if (response.data.response) {
              vm.cerrarModal();
              vm.getPuntosMapa();

              vm.$notify({
                message: vm.$t("zonaCreadaCorrectamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: vm.$t("error"),
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    checkCampos(formulario) {
      //E de edición
      if (formulario == "E") {
        //Si tiene el nombre en blanco, se rechaza
        if (
          this.areaAEditar.nombre == "" ||
          this.areaAEditar.nombre == undefined
        ) {
          swal({
            title: this.$t("atencion"),
            text: this.$t("laZonaNoPuedeTenerElNombreEnBlanco"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          return false;
        } else {
          //Si no, se acepta
          return true;
        }
        //N de nuevo
      } else if (formulario == "N") {
        //Si tiene el nombre en blanco, se rechaza
        if (this.areaNueva.nombre == "" || this.areaNueva.nombre == undefined) {
          swal({
            title: this.$t("atencion"),
            text: this.$t("laZonaNoPuedeTenerElNombreEnBlanco"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          return false;
        } else {
          //Si no, se acepta
          return true;
        }
      }
    },
    comprobarConfiguracion() {
      let vm = this;
      //mapaReparto
      let idConfigZonaReparto = 54;

      //Preparo la petición
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idConfig: idConfigZonaReparto,
          idTpv: this.idTpv,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      //Mando la petición
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfig", config)
        .then(function(response) {
          vm.inProgress = false;

          if (response.data.response) {
            if (response.data.result) {
              vm.permisos = true;
            } else {
              vm.permisos = false;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    editarZona() {
      if (this.checkCampos("E")) {
        this.inProgress = true;

        let vm = this;
        //Preparo y recojo los datos

        let idArea = this.idAreaSeleccionada;

        this.areaAEditar.id = idArea;

        //Recorro la lista de polígonos actualizados
        this.listPolygons.forEach((poligono) => {
          if (poligono.customID == this.areaAEditar.id) {
            if(this.areaAEditar.tipo == "Z") {
              var len = poligono.getPath().getLength();

              const puntos = [];

              for (var i = 0; i < len; i++) {
                const lat = poligono
                  .getPath()
                  .getAt(i)
                  .lat();
                const lng = poligono
                  .getPath()
                  .getAt(i)
                  .lng();
                puntos.push(new google.maps.LatLng(lat, lng));
              }

              //Añado el polígono a la zona a editar
              this.areaAEditar.puntosPoligono = JSON.stringify(puntos);
            } else if (this.areaAEditar.tipo == "R") {
              this.areaAEditar.puntosPoligono = '{"center": '+JSON.stringify(poligono.getCenter())+',"radius": '+this.radioZona * 1000+'}';
            }
          }
        });

        //Preparo la petición
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idTpv: this.idTpv,
          area: this.areaAEditar,
        };

        //Mando la petición
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/editZona",
            params,
            config
          )
          .then(function(response) {
            vm.inProgress = false;

            if (response.data.response) {
              vm.cerrarModal();
              vm.getPuntosMapa();

              vm.$notify({
                message: vm.$t("zonaEditadaCorrectamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: vm.$t("error"),
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    abrirModalEliminar() {
      swal({
        title: this.$t("estasSeguroDeQueQuieresEliminarLaZona"),
        text: this.$t(
          "estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos"
        ),
        type: "error",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siEliminarZona"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.borrarZona();
        }
      });
    },
    borrarZona() {
      let vm = this;
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idArea: this.idAreaSeleccionada,
      };

      //Mando la petición
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/borrarZona",
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.cerrarModal();
            vm.getPuntosMapa();

            vm.$notify({
              message: vm.$t("zonaEliminadaCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    guardarMapa() {
      const list = [];
      let zona = {
        id: "",
        puntos: "",
      };
      this.listPolygons.forEach((poligono) => {
        if(!poligono.radius) {
          var len = poligono.getPath().getLength();
          const puntos = [];
          for (var i = 0; i < len; i++) {
            const lat = poligono
              .getPath()
              .getAt(i)
              .lat();
            const lng = poligono
              .getPath()
              .getAt(i)
              .lng();
            puntos.push(new google.maps.LatLng(lat, lng));
          }
          list.push({ id: poligono.customID, puntos: JSON.stringify(puntos) });
          //list.push(puntos);
        } else {
          list.push({ id: poligono.customID, puntos: '{"center": '+JSON.stringify(poligono.getCenter())+',"radius": '+poligono.radius+'}'});
        }
      });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idTpv: this.idTpv,
        listaPoligonos: list,

        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "guardarMapaZonas";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("zonasActualizadasCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          }
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;

              vm.comprobarConfiguracion();
            }
            vm.getConfigTpv();

            vm.getCoordenadas();
            vm.getPuntosMapa();
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    getCoordenadas() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getCoordenadas", config)
        .then(function(response) {
          if (response.data.response) {
            vm.negocioLat = response.data.result.latitud;
            vm.negocioLng = response.data.result.longitud;
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    cambiarZonaActual() {
      this.listaAreas.forEach((area) => {
        if (area.id == this.idAreaSeleccionada) {
          let areaNueva = area;
          this.areaSeleccionada = areaNueva;
        }

        //Permito que sea editable el polígono que se ha clickado
        this.listPolygons.forEach((polygon) => {
          if (polygon.customID == this.idAreaSeleccionada) {
            polygon.setOptions({ draggable: true, editable: true });
          } else {
            polygon.setOptions({ draggable: false, editable: false });
          }
        });
      });
    },
    initialize() {
      // Map Center

      if (
        this.negocioLat == "" ||
        this.negocioLng == "" ||
        this.negocioLat == undefined ||
        this.negocioLng == undefined
      ) {
        var myLatLng = new google.maps.LatLng(this.center.lat, this.center.lng);
      } else {
        var myLatLng = new google.maps.LatLng(this.negocioLat, this.negocioLng);
      }

      // General Options
      var mapOptions = {
        zoom: this.zoom,
        center: myLatLng,
        mapTypeId: google.maps.MapTypeId.RoadMap,
      };
      this.map = new google.maps.Map(
        document.getElementById("map-canvas"),
        mapOptions
      );
    },
    calcularCentro() {
      if (this.listaAreas.length > 0) {
        var bounds = new google.maps.LatLngBounds();

        this.listaAreas.forEach((area) => {
          if(area.tipo == 'Z') {
            area.puntosPoligono.forEach((punto) => {
              bounds.extend(new google.maps.LatLng(punto.lat, punto.lng));
            });
          } else if (area.tipo == 'R') {
            bounds.extend(new google.maps.LatLng(area.puntosPoligono.center.lat, area.puntosPoligono.center.lng));
          }
        });

        this.map.fitBounds(bounds);
        this.map.setCenter(bounds.getCenter());
      } else {
      }
    },
    calcularZoom() {
      //valores 0 a 21
      let maxLeft,
        maxRight,
        maxTop,
        maxBottom = null;

      if (this.listaAreas.length > 0) {
        this.listaAreas.forEach((area) => {
          if(area.tipo == 'Z') {
            area.puntosPoligono.forEach((poligono) => {
              maxLeft =
                !maxLeft || poligono.lng < maxLeft ? poligono.lng : maxLeft;
              maxRight =
                !maxRight || poligono.lng > maxRight ? poligono.lng : maxRight;
              maxTop = !maxTop || poligono.lat < maxTop ? poligono.lat : maxTop;
              maxBottom =
                !maxBottom || poligono.lat > maxBottom ? poligono.lat : maxBottom;
            });
          } else if (area.tipo == 'R') {
            maxLeft = !maxLeft || area.puntosPoligono.center.lng < maxLeft ? area.puntosPoligono.center.lng : maxLeft;
            maxRight = !maxRight || area.puntosPoligono.center.lng > maxRight ? area.puntosPoligono.center.lng : maxRight;
            maxTop = !maxTop || area.puntosPoligono.center.lat < maxTop ? area.puntosPoligono.center.lat : maxTop;
            maxBottom = !maxBottom || area.puntosPoligono.center.lat > maxBottom ? area.puntosPoligono.center.lat : maxBottom;
          }
        });

        const metrosDistancia = google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(maxLeft, maxTop),
          new google.maps.LatLng(maxRight, maxBottom)
        );
        const zoom = 15 - Math.floor(metrosDistancia) / 10000;

        return zoom;
      } else {
        const zoom = 16;

        return zoom;
      }
    },
    /*addCircle() {
      const punta1 = 0.001;

      const punta2 = 0.002;

      const punto = [
        new google.maps.LatLng(
          parseFloat(this.map.getCenter().lat() - punta2).toFixed(6),
          parseFloat(this.map.getCenter().lng() + punta2).toFixed(6)
        ),
        new google.maps.LatLng(
          parseFloat(this.map.getCenter().lat() + punta2).toFixed(6),
          parseFloat(this.map.getCenter().lng() + punta2).toFixed(6)
        ),
        new google.maps.LatLng(
          parseFloat(this.map.getCenter().lat() + punta2).toFixed(6),
          parseFloat(this.map.getCenter().lng() - punta2).toFixed(6)
        ),
        new google.maps.LatLng(
          parseFloat(this.map.getCenter().lat() - punta2).toFixed(6),
          parseFloat(this.map.getCenter().lng() - punta2).toFixed(6)
        ),
      ];
      console.log(punto);
      console.log(this.map.getCenter().lat() + ' ' + this.map.getCenter().lng()+' / '+this.center.lat);
      //this.listaAreas = [];
      //this.listaAreas.push(punto);
      this.anadirPoligonoMapa(punto);
    },*/
  },
  mounted() {
    this.getBusiness();
  },
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
  },
};
</script>
<style lang="css">
#cabecera .card {
  margin-bottom: 10px !important;
}
</style>
<style lang="scss" scoped>
body {
  background: #222;
}
h3 {
  margin: 4px 0;
  padding: 5px 0;
  font-family: arial, sans-serif;
  width: 100%;
  color: #fff;
}
a li {
  color: #111;
}
a {
  font-family: arial, sans-serif;
  color: #00b2ee;
  text-decoration: none;
}
#map-canvas {
  width: auto;
  height: 500px;
}
#info {
  color: #222;
}
#clipboard-btn {
  float: left;
  margin-right: 10px;
  padding: 6px 8px;
}
#info {
  height: 140px;
  float: left;
  margin-bottom: 30px;
  border: solid 2px #eee;
}
#info,
.lngLat {
  font-family: arial, sans-serif;
  font-size: 12px;
  padding-top: 10px;
  width: 270px;
}

.card {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Zonas/ZonasCarta.vue